import { createContext, useContext } from "react";
import type { AdminSession } from "@/lib/session";

/**
 * Kept apart from SessionGate so that file exports a component and nothing
 * else. A module exporting both a component and a hook loses Vite's fast
 * refresh for every edit to it, and SessionGate wraps the entire app.
 */
export const SessionContext = createContext<AdminSession | null>(null);

export function useSession(): AdminSession {
  const s = useContext(SessionContext);
  if (!s) throw new Error("SessionGate not mounted");
  return s;
}
